/*
 * Example usage:
 * const filterBy = ['departmentName', 'departmentNumber'];
 * const updatedList = filterList(this.props.allotments, filterBy, inputValue);
 * this.setDepartmentList(updatedList);
 */

const normalizeValue = value => (value ? encodeURI(value.toString().toLowerCase()) : '');

const filterObject = (object, objectKeys, inputVal) => {
  const normalizeInput = normalizeValue(inputVal);
  return objectKeys.some(key => normalizeValue(object[key]).search(normalizeInput) !== -1);
};

export function filterList(list, objectKeys, inputVal) {
  return Array.isArray(list) ? list.filter(object => filterObject(object, objectKeys, inputVal)) : [];
}
